import { render, staticRenderFns } from "./LegacyBookingRedirect.vue?vue&type=template&id=005dbd6b&"
import script from "./LegacyBookingRedirect.vue?vue&type=script&lang=ts&"
export * from "./LegacyBookingRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports